import React from 'react'
import { Status } from '../../../__generated__/graphql'
import DisplayedItem from '../../../components/form/DisplayedItem'
import { StatusStyled } from '../../../components/StatusStyled'
import { ArchiveEntityStatusField } from '../../../components/archiveEntity/ArchiveEntityStatusField'
import { useProgrammaticCampaignArchiveEligibility } from '../../../components/archiveEntity/useProgrammaticCampaignArchiveEligibility'

export const ProgrammaticCampaignStatusForm: React.FC<{
  campaign: { id: string; status: Status }
  editable: boolean
}> = ({ campaign, editable }) => {
  const { canArchive } = useProgrammaticCampaignArchiveEligibility(campaign.id, campaign.status)

  if (canArchive) {
    return <ArchiveEntityStatusField editable={editable} name="status" status={campaign.status} />
  }

  return (
    <DisplayedItem label="commons.status" name="status">
      <StatusStyled status={campaign.status} />
    </DisplayedItem>
  )
}
